style= require('./create-new-receiver.styl')

.modal-header
  .modal-title='Create receiver'
  ft-icon.close(name='ui--cross', (click)= this.closeModal())
form
  .row
    .col
      label Name
      input(
        type="text"
        name="name"
        required
        placeholder="name")
    .col
      label Url
      input(
        type="text"
        name="url"
        required
        placeholder="https://destination.site/endpoint")
    .col
      span
      label
        input(
          type="checkbox"
          name="isInplayFantasy")
        = "is Inplay Fantasy"
  .footer
    button(type="button", (click)=this.createReceiver()) Create

